import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { IState } from 'models/reducers/i-state.interface';

import { ROUTES } from 'constants/routes.constant';

import SpotlightNftCard from 'routes/spotlight/spotlightNftCard/SpotlightNftCard';

import Button from 'components/buttons/Button';

const PromotionsNftCard = () => {
  const navigate = useNavigate();

  const { offers, assets } = useSelector((state: IState) => state.nftOfTheDay);
  const todayAsset = assets.find(({ id }) => id === offers[0]?.asset_id);

  if (!todayAsset) return null;

  return (
    <div className="tw-mx-auto tw-mb-2.5 tw-flex tw-h-fit tw-w-[330px] tw-flex-col tw-gap-y-5 tw-rounded-3xl tw-border-2 tw-border-solid tw-border-skyBlue tw-bg-blueCardGradient tw-px-4 tw-py-7.5 lg:tw-min-w-full xl:tw-px-10">
      <h2 className="tw-text-center tw-text-[32px]/[28px] tw-uppercase tw-text-white lg:tw-text-5xl">
        ASSET of the <span className="tw-text-turquoise">day</span>
      </h2>
      <SpotlightNftCard asset={todayAsset} className="tw-min-w-[300px] lg:tw-min-w-[256px] xl:tw-min-w-[256px]" />
      <h3 className="tw-text-center tw-text-[28px]/[28px] tw-uppercase tw-text-white">
        5% bonus granted from all royalties
      </h3>
      <Button color="white-outline" text="Earn now" twClassName="tw-mb-5" onClick={() => navigate(ROUTES.SPOTLIGHT)} />
    </div>
  );
};

export default PromotionsNftCard;
